import { ThemeColorNames } from '@sites/site-theme/src/enums/color-names.enum';

import { EButtonLinkType, EHorizontalPosition, EMenuLayoutType, ESize, Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';

import { type WebWidgetModel } from '@web/types';
import { type NavigationWidgetData } from '@web/widgets/navigation/type/navigation-widget.type';
import { EffectTypes } from '@web/shared/components/web-hover-effects/types';

import { NavigationViewComponent } from '@web/widgets/navigation/components/navigation-view/navigation-view.component';
import { NavigationControlComponent } from '@web/widgets/navigation/components/navigation-control/navigation-control.component';
import { createId } from '@paralleldrive/cuid2';

// DEFAULT COMPONENT SETTINGS
const navigationData = (): NavigationWidgetData => ({
    menuList: [
        {
            name: 'Home',
            linkUrl: 'https://example.com',
            linkType: EButtonLinkType.link,
            isVisible: true,
            id: createId(),
        },
        {
            name: 'Phone',
            linkUrl: '0501111111',
            linkType: EButtonLinkType.phone,
            isVisible: true,
            id: createId(),
        },
        {
            name: 'Learn more',
            linkUrl: 'id-568222',
            linkType: EButtonLinkType.anchor,
            isVisible: false,
            id: createId(),
        },
    ],
    textColor: '#1b1b1b',
    submenuTextColor: '#1b1b1b',
    fontSize: 16,
    submenuFontSize: 16,
    menuItemIndent: ESize.S,
    horizontalPosition: EHorizontalPosition.R,
    layoutDirection: EMenuLayoutType.HORIZONTAL,
    fontStyle: [],
    submenuFontStyle: [],
    submenuListBackground: '#fff',
    hoverEffects: {
        type: EffectTypes.transparency,
        transparency: 80,
        lineWidth: 1,
        color: ThemeColorNames.primary,
        lineType: 'solid',
        animationType: 'moving_up',
    },
});
// END DEFAULT SETTINGS

export const navigationWidgetModel: WebWidgetModel = {
    componentView: NavigationViewComponent,
    componentControl: NavigationControlComponent,
    name: Widgets.NAVIGATION,
    label: 'widget_menu_label',
    data: navigationData,
    permission: defaultWidgetPermission,
    params: { ...defaultWidgetParams, type: ['specific'] },
};
